import React, { useState, useEffect, useLayoutEffect } from 'react'
import { Outlet, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { Modal, Container } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash'
import { toastr } from 'react-redux-toastr'
import { useTranslation } from 'react-i18next'

import CustomButton from './CustomButton'
import HeaderNav from './dump/HeaderNav'
import Footer from './dump/Footer'
import SideMenu from './dump/menu/SideMenu';
import ModalDelete from './smart/modals/ModalDelete'
import SessionNotificationsPolling from './SessionNotificationsPolling'
import ModalLayout from './common/modals/ModalLayout'
import ModalNewMapOptions from './smart/modals/ModalNewMapOptions'

import { getDevicesProblems, getUserInfo, getVersion } from '../action/ClientActions';
import { prefetchData } from '../utils/prefetchData';
import { getDomain } from './helpers/helperRedirect';

import { getFirmwareBlacklist, getPartnerSettings } from "../action/CompaniesActions";
import { getProfilesConfigs } from "../action/CustomActions";
import { useAuth } from "../../../context/AuthContext";
import TokenManager from "../utils/storage/TokenManager";

import './Layout.sass';

const Layout = (props) => {
	const { logout } = useAuth();
	const navigate = useNavigate();
	const { t } = useTranslation('translation', { keyPrefix: 'components.layout' });
	const { user, company, whitelabel, loader, partnerPortalRedirect, toggleCustomLoader, sideMenuOpen, notification, toggleGlobalPopup, dashboardLoaded } = props
	const isHomePage = location.pathname === '/';
	const isMapPage = location.pathname === '/map';
	const isZonesPage = location.pathname === '/zones';

	const [interval, setIntervals] = useState(null);
	const [userinfo, setUserinfo] = useState({});
	const [isSessionExpired, setIsSessionExpired] = useState(false)
	const [isUserInfoLoaded, setIsUserInfoLoaded] = useState(false)
	const [showModalNewMapOptions, setShowModalNewMapOptions] = useState(false)

	useEffect(() => {
		if (isUserInfoLoaded && user && window.pendo) {
			window.pendo.initialize({
				visitor: {
					id: user.id,
					email: user.email,
					firstName: user.first_name,
					lastName: user.last_name,
				},
			});
		}
	}, [user, isUserInfoLoaded]);

	useLayoutEffect(() => {
		const { updateUser } = props;

		// setTimeout(async () => {
		// 	await logout(true);
		// 	setIsSessionExpired(true);
		// }, 86400000);

		getUserInfo()
			.then(async (res) => {
				const { user } = res.data.response;
				if (!user.eula_was_viewed) {
					navigate('/eula-agreement', {
						replace: true,
					});
				} else if (['partner', 'custom_partner', 'partner_view'].includes(user.roles[0]) && location.pathname === '/' && !partnerPortalRedirect.portal_url) {
					// ToDo: Cognito - disable
					const s_t = await TokenManager.getSessionToken();
					// const a_t = await TokenManager.getAccessToken();
					// const r_t = await TokenManager.getRefreshToken();
					// let url = `${getDomain()}/sso#a_t=${encodeURIComponent(a_t)}&r_t=${encodeURIComponent(r_t)}`;
					let url = `${getDomain()}/sso#s_t=${encodeURIComponent(s_t)}`;
					window.location.assign(url);
				} else {
					// FWSD-5431, display the Firmware Portal menu option only if the company exists in the Firmware Rollout blacklist.
					// user.has_company_firmware_blacklist is marker if company of FleetManaged exists in firmware blacklist
					if (user.roles[0] === 'fleet_manager') {
						const firmwareBlacklist = await getFirmwareBlacklist()
							.then((res) => {
								return res
							})
							.catch((error) => {
								let errDescription = t('errFirmwareBlacklist')
								if (error.response?.data?.response?.error) {
									errDescription = error.response.data.response.error
								}
								toastr.error(errDescription)
							})
						user.has_company_firmware_blacklist = !!firmwareBlacklist.data.response.filter(({ company_id }) => company_id === user.company_id).length
					}

					updateUser(user);
					setIsUserInfoLoaded(true);
					getLastRelease(user);
					getDefaultDeviceConfigs();
				}
			})
			.catch(async (error) => {
				console.log('!getUserInfo componentWillMount error: ', error.response, error);

				await logout();
				location.href = '/';
			});
		// Receives list of the partner whitelabel settings - FWSD-4278
		getPartnerWhitelabelSetting()
	}, []);

	useEffect(() => {
		if (isMobileOnly) {
			document.body.classList.add('mobile');
		}
	}, [])

	useEffect(() => {
		if (isUserInfoLoaded && company && user && company.company_id) {
			getCompanyDevicesProblems(user)
		}

		return () => {
			if (interval) {
				clearInterval(interval)
				setIntervals(null)
			}
			localStorage.removeItem("isTimeSession");
		}
	}, [company.company_id, isUserInfoLoaded]);

	useEffect(() => {
		if (isUserInfoLoaded && company && user && company.company_id && (dashboardLoaded || !isHomePage)) {
			prefetchData(user.roles?.[0], company)
		}
	}, [company.company_id, dashboardLoaded, isHomePage, isUserInfoLoaded]);

	// Receives list of the partner whitelabel settings - FWSD-4278
	const getPartnerWhitelabelSetting = () => {
		const { updatePartnerWhitelabel } = props;
		getPartnerSettings()
			.then((res) => {
				const { settings } = res.data.response
				if (!_.isEmpty(settings)) {
					updatePartnerWhitelabel(JSON.parse(settings.settings))
				}
			})
			.catch((error) => {
				console.log('!getPartnerWhitelabelSetting error: ', error.response, error)
			})
	}

	const getLastRelease = () => {
		const { updateProjectVersion } = props;

		getVersion()
			.then((res, err) => {
				const version = res.data.response
				updateProjectVersion(version)
			})
			.catch((error) => {
				console.log('!getProjectVersion error: ', error)
			})
	}

	const getCompanyDevicesProblems = (argUser) => {
		const { updateIsDevicesHaveProblems, company } = props;
		const userRole = argUser.roles[0];

		if (userRole === 'partner' && !company.name) {
			return
		}

		getDevicesProblems({ company_id: company.company_id })
			.then((res) => {
				const devicesHaveProblems = _.has(res.data.response, 'is_red_bubble') && res.data.response.is_red_bubble
				updateIsDevicesHaveProblems(devicesHaveProblems)
			})
			.catch((err) => {
				console.log('getCompanyDevices error: ', err)
			})

		if (interval) {
			clearInterval(interval)
			setIntervals(null)
		}
		setIntervals(setInterval(() => {
			getDevicesProblems({ company_id: company.company_id })
				.then((res) => {
					const devicesHaveProblems = _.has(res.data.response, 'is_red_bubble') && res.data.response.is_red_bubble
					updateIsDevicesHaveProblems(devicesHaveProblems)
				})
				.catch((err) => {
					console.log('getCompanyDevices error: ', err)
				})
		}, 1800000)) // 30mins
	}

	const getDefaultDeviceConfigs = () => {
		const { updateDefaultDeviceConfigs } = props

		getProfilesConfigs({ device_type: 'dv4,dv6,dv7' })
			.then((res) => {
				const { dv4, dv6, dv7 } = res.data.response

				updateDefaultDeviceConfigs({
					defaultConfiguration: JSON.parse(dv4),
					defaultConfigurationDv6: JSON.parse(dv6),
					defaultConfigurationDv7: JSON.parse(dv7),
				})
			})
			.catch((error) => {
				toastr.error('Error to get default device configs')
				console.log('!getDefaultDeviceConfigs error: ', error)
			})
	}

	// FWSD-4276
	const isCustomLoaderExists = _.get(whitelabel, 'loader');

	isCustomLoaderExists && toggleCustomLoader(true);

	const isUserExist = user.roles;
	if (!isUserExist || !isUserInfoLoaded) {
		return (
			<div id="" className="container-fluid" />
		)
	}

	return (
		<Container fluid className="base-wrapper-container p-0 m-0">
			<SideMenu />
			<HeaderNav
				userinfo={userinfo}
				isHomePage={isHomePage}
				onTryNewMap={() => setShowModalNewMapOptions(true)}
			/>
			<div className={`right-content-big-block ${sideMenuOpen ? '' : 'wider'}`}>

				<Outlet />

				{!isHomePage && !isMapPage && !isZonesPage && <Footer />}

				{loader}
			</div>

			{/* Polling for global/session notifications */}
			<SessionNotificationsPolling
				notification={notification}
				setSessionDevicesIds={props.setSessionDevicesIds}
				setGlobalPopupData={props.setGlobalPopupData}
				toggleGlobalPopup={props.toggleGlobalPopup}
				setSessionNotifications={props.setSessionNotifications}
			/>

			{/* FWSD-7345, this is global popup available on any page of app. Currently is just used to display the "Live Stream Ready" message. */}
			{notification.showGlobalPopup &&
				<ModalDelete
					title={t('modalDeletetitle')}
					content={t('modalDeletecontent', { vehicleName: notification.globalPopupData.vehicle_name })}
					styleView="primary"
					backdropClassName="upper"
					closeButton={false}
					showClose
					deleteBtnName={t('deleteBtnName')}
					closeBtnName={t('closeBtnName')}
					closeModal={() => toggleGlobalPopup(false)}
					deleteModal={() => {
						toggleGlobalPopup(false)
						const el = document.getElementById('user-notifications-btn').querySelector('button')
						if (el) {
							el.click()
						}
					}}
				/>
			}

			{/* FWSD-7380 */}
			{showModalNewMapOptions &&
				<ModalNewMapOptions
					onHide={() => setShowModalNewMapOptions(false)}
				/>
			}

			{/* FWSD-7159, displays two popups with notes about archived popups */}
			<ModalLayout />

			<Modal
				show={isSessionExpired}
				dialogClassName="has-error"
				keyboard={false}
				backdrop="static"
			>
				<Modal.Body bsPrefix="modal-body modal-body-custom release-modal">
					<div className="title">{t('titleSessionExpired')}</div>
				</Modal.Body>
				<Modal.Footer bsPrefix="modal-footer">
					<CustomButton
						onClick={() => navigate('/login', { replace: true })}
						variant="primary-outline"
					>
						{t('btnOk')}
					</CustomButton>
				</Modal.Footer>
			</Modal>
		</Container>
	)
}

Layout.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	whitelabel: PropTypes.objectOf(PropTypes.any).isRequired,
	updateUser: PropTypes.func.isRequired,
	updateProjectVersion: PropTypes.func.isRequired,
	updateIsDevicesHaveProblems: PropTypes.func.isRequired,
	updatePartnerWhitelabel: PropTypes.func.isRequired
}

const mapStateToProps = ({ user, company, loader, partnerPortalRedirect, dashboardData, notification, eventsData }) => ({
	user: user.user,
	whitelabel: user.whitelabel,
	company: company.company,
	partnerPortalRedirect: partnerPortalRedirect,
	loader: loader.loader,
	sideMenuOpen: dashboardData.sideMenuOpen,
	dashboardLoaded: dashboardData.dashboardLoaded,
	notification,
})

const mapDispatchToProps = dispatch => ({
	updateUser: (user) => {
		dispatch({ type: 'GET_USER_SUCCESS', payload: user });
	},
	updateProjectVersion: (version) => {
		dispatch({ type: 'SET_PROJECT_VERSION', payload: version });
	},
	updateIsDevicesHaveProblems: (state) => {
		dispatch({ type: 'SET_IS_DEVICES_HAVE_PROBLEMS', payload: state });
	},
	updatePartnerWhitelabel: (state) => {
		dispatch({ type: 'SET_WHITELABEL_SETTINGS', payload: state });
	},
	toggleCustomLoader: (show) => {
		dispatch({ type: 'TOGGLE_CUSTOMLOADER', payload: show });
	},
	toggleGlobalPopup: (show) => {
		dispatch({ type: 'TOGGLE_GLOBAL_POPUP', payload: show });
	},
	setSessionDevicesIds: (state) => {
		dispatch({ type: 'SET_SESSION_DEVICES_IDS', payload: state });
	},
	setGlobalPopupData: (state) => {
		dispatch({ type: 'SET_GLOBAL_POPUP_DATA', payload: state });
	},
	setSessionNotifications: (state) => {
		dispatch({ type: 'SET_SESSION_NOTIFICATIONS', payload: state });
	},
	updateDefaultDeviceConfigs: (configs) => {
		dispatch({ type: 'GET_DEFAULT_CONFIGS_SUCCESS', payload: configs });
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
